<template>
  <div id="navBar">
    <v-toolbar flat>
      <v-toolbar-title>
        <router-link class="logoText" to="/"> R E T H Y M O S</router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu class="hidden-md-and-up">
        <v-toolbar-side-icon slot="activator"></v-toolbar-side-icon>
        <v-list dense>
          <!-- <v-list-tile>
                        <v-list-tile-content>
                            <v-list-tile active-class="depressed" to="/" 
                                v-scroll-to="{el: '#anchor2', offset: -50}" @click="active = !active"
                                v-bind:class="{ activeNav: active }">About Us</v-list-tile>
                        </v-list-tile-content>
                    </v-list-tile> -->
          <v-list-tile v-for="(each, index) in navigationFill" :key="index">
            <v-list-tile-content>
              <v-list-tile :to="each.destination">
                <v-btn depressed color="white" style="width: 120px">
                  {{ each.tabName }}</v-btn
                ></v-list-tile
              >
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
      <!-- <v-toolbar-items class="hidden-sm-and-down">
                <v-btn id="aboutButton" @click="toggleLanding" active-class="depressed" to="/" block flat
                    class="navItems" href="#">
                    About Us</v-btn>
            </v-toolbar-items> -->
      <v-toolbar-items
        class="hidden-sm-and-down"
        v-for="(each, index) in navigationFill"
        :key="index"
      >
        <v-btn
          class="navItems"
          active-class="activeNav"
          block
          flat
          :to="each.destination"
        >
          {{ each.tabName }}
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: ["Technology Services", "Business Development", "Employment"],
      navigationFill: [
        {
          destination: "/about",
          tabName: "About Us",
        },
        {
          destination: "/strategy",
          tabName: "Strategic Consulting",
        },
        {
          destination: "/business",
          tabName: "Business Development",
        },
        {
          destination: "/team",
          tabName: "Meet Our Team",
        },
        {
          destination: "/contact",
          tabName: "Contact Us",
        },
      ],
    };
  },
  // methods: {
  //     toggleLanding: function (event) {
  //         var aboutButton = document.getElementById('aboutButton');
  //         aboutButton.classList.add("activeNav");
  //         this.$emit('button-clicked')
  //     },
  //     logoClicked: function (event) {
  //         var aboutButton = document.getElementById('aboutButton');
  //         aboutButton.classList.remove("activeNav");
  //         this.$emit('logo-clicked')
  //     }
  // }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Play");
@import url("https://fonts.googleapis.com/css?family=Rajdhani");

.activeNav {
  color: #18519a;
  font-weight: bold;
  font-size: 20px;
  letter-spacing: 3px !important;
  font-family: "Rajdhani", sans-serif;
}

.navItems {
  font-family: "Rajdhani", sans-serif;
  letter-spacing: 2px;
  font-size: 19px;
  font-weight: medium;
}

/* .v-btn {
  width: 120px;
}
.v-menu {
  margin-right: 0px;
} */
</style>